import { hocs as pageHocs, SimplePageLayout } from 'modules/page';
import { memo } from 'react';

import AcceptInvitationContent from './component/AcceptInvitationContent/AcceptInvitationContent';
import useAcceptInvitationPageData from './hooks/useAcceptInvitationPageData';

const AcceptInvitationPage = () => {
    const { isLoading } = useAcceptInvitationPageData();

    if (isLoading) {
        return null;
    }

    return (
        <SimplePageLayout showMobileAppButtons>
            <AcceptInvitationContent />
        </SimplePageLayout>
    );
};

export default pageHocs.withProtected({ Page: memo(AcceptInvitationPage) });
